import React, { useState } from 'react';
import {
  Button,
  Dialog,
  Stack,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Typography
} from '@material-ui/core';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useQuery } from 'react-query';
import { approveAndExportRequests, exportRequests } from 'src/services/admin.service';
import * as dayjs from 'dayjs';

function AdminExportButton() {
  const [open, setOpen] = useState(false);
  const [exportByDate, setExportByDate] = useState(true);
  const [fromDate, setFromDate] = useState(dayjs(new Date().setMonth(new Date().getMonth() - 1)));
  const [rate, setRate] = useState(0);
  const [toDate, setToDate] = useState(dayjs(new Date()));
  const [enableExport, setEnableExport] = useState(false);
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { isLoading, isError, isRefetching } = useQuery(
    'export',
    async () => {
      const params = new URLSearchParams();
      params.set('from', new Date(fromDate.toDate()).toISOString().split('T')[0]);
      params.set('to', new Date(toDate.toDate()).toISOString().split('T')[0]);
      params.set('exportByDate', exportByDate.toString());
      params.set('rate', rate);
      await exportRequests({ params });
      setEnableExport(false);
      setTimeout(() => {
        setOpen(false);
      }, 300);
    },
    {
      enabled: enableExport,
      cacheTime: 0
    }
  );

  const approveAndExport = async () => {
    try {
      // setEnableExport(true)
      const params = new URLSearchParams();
      params.set('from', new Date(fromDate.toDate()).toISOString().split('T')[0]);
      params.set('to', new Date(toDate.toDate()).toISOString().split('T')[0]);
      params.set('exportByDate', exportByDate.toString());
      params.set('rate', rate);
      debugger;
      await approveAndExportRequests({ params });
    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => {
        setEnableExport(false);
        setOpen(false);
      }, 300);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={() => setOpen(true)}
        startIcon={<FileDownloadIcon sx={{ color: '#fff' }} />}
      >
        Export
      </Button>
      <Dialog
        open={open}
        maxWidth="lg"
        onClose={() => {
          setOpen(false);
          setEnableExport(false);
        }}
      >
        <Stack
          style={{
            minHeight: '15vh',
            gap: '2rem',
            width: isLargeScreen ? '30vw' : isSmallScreen ? '80vw' : '50vw',
            padding: '2rem'
          }}
          justifyContent="between"
          alignItems="left"
          direction="column"
        >
          <FormLabel style={{ fontWeight: 'bold', color: 'black' }}>Export requests</FormLabel>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="date"
              name="radio-buttons-group"
              row
              onChange={(e) => setExportByDate(e.target.value === 'date')}
            >
              <FormControlLabel value="date" control={<Radio />} label="Export by date" />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker', 'DatePicker']}>
                  <DatePicker
                    label="From"
                    slotProps={{ textField: { variant: 'outlined' } }}
                    value={fromDate}
                    onChange={(newValue) => {
                      setFromDate(dayjs(newValue));
                    }}
                    disabled={!exportByDate}
                  />
                  <DatePicker
                    label="To"
                    slotProps={{ textField: { variant: 'outlined' } }}
                    value={toDate}
                    onChange={(newValue) => {
                      setToDate(dayjs(newValue));
                    }}
                    disabled={!exportByDate}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <FormControlLabel value="exported" control={<Radio />} label="Export non exported" />
            </RadioGroup>
          </FormControl>
          <FormControl>
            <TextField
              label="Rate"
              type="number"
              value={rate}
              inputProps={{ min: 0 }}
              onChange={(e) => setRate(Number(e.target.value))}
              disabled={!exportByDate}
            />
          </FormControl>
          <Stack gap="8px">
            <Button
              onClick={() => setEnableExport(true)}
              disabled={isLoading || isRefetching || rate < 1}
              fullWidth
              variant="contained"
              color="primary"
              style={{ marginTop: 0 }}
            >
              {isLoading || isRefetching ? 'loading...' : 'Export'}
            </Button>
            <Button
              onClick={approveAndExport}
              disabled={isLoading || isRefetching || rate < 1 || !exportByDate}
              fullWidth
              variant="contained"
              color="primary"
              style={{ marginTop: 0 }}
            >
              Approve & Export
            </Button>
            {isError && (
              <Typography color={'error'} fontSize={'14px'}>
                Something went wrong. Try again or contact your administrator
              </Typography>
            )}
          </Stack>
        </Stack>
      </Dialog>
    </>
  );
}

export default AdminExportButton;
